import { Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface DirectoryStatusBadgeProps {
  status: string | null;
  professionalType: string | null;
}

export function DirectoryStatusBadge({ status, professionalType }: DirectoryStatusBadgeProps) {
  const { t } = useTranslation();

  if (!professionalType) {
    return <Badge bg="secondary">{t('pelnomocnicy.directory.notFound')}</Badge>;
  }

  if (status === 'Active') {
    return <Badge bg="success">{t('pelnomocnicy.directory.active')}</Badge>;
  }

  if (status === 'Inactive' || status === 'Former') {
    return (
      <Badge bg="danger">
        {t(`pelnomocnicy.directory.${status === 'Inactive' ? 'inactive' : 'former'}`)}
      </Badge>
    );
  }

  // Matched but no status info
  return <Badge bg="success">{t('pelnomocnicy.directory.verified')}</Badge>;
}
